export const IMPORT_RESULT_SAVE_RESULTS = 'IMPORT_RESULT_SAVE_RESULTS';
export const IMPORT_RESULT_SAVE_RESULT = 'IMPORT_RESULT_SAVE_RESULT';
export const IMPORT_RESULT_FETCHING = 'IMPORT_RESULT_FETCHING';
export const IMPORT_RESULT_FETCH_ERROR = 'IMPORT_RESULT_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/pages/importresult/state/resultgrid/types.js